//#region INTERFACE
interface Props {
  removeHandler?: (value: string) => void;
  value: string;
}
//#endregion

export default function InstoreOrderFormCommentBadge({
  removeHandler,
  value,
}: Props) {
  //#region RENDER
  return (
    <span className="inline-flex items-center gap-x-1 rounded-md bg-sky-200 px-3 py-2 text-xs font-medium text-sky-800">
      {value}
      {removeHandler ? (
        <button
          type="button"
          className="group relative -mr-1 size-3.5 rounded-xs hover:bg-indigo-600/20 dark:hover:bg-indigo-400/20"
          onClick={() => removeHandler(value)}
        >
          <svg
            viewBox="0 0 14 14"
            className="h-4 w-4 stroke-sky-800/50 group-hover:stroke-sky-800/75"
          >
            <path d="M4 4l6 6m0-6l-6 6" />
          </svg>
        </button>
      ) : null}
    </span>
  );
  //#endregion
}
